import { useState, useEffect } from 'react'
import { getRequest } from '../../globalhelper/helper'
import NewDynamicTable from './NewDynamicTable'
import { CSVLink } from 'react-csv'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Alert,
  AlertTitle,
  Autocomplete,
  Box,
  Button,
  Grid,
  TextField,
  Typography
} from '@mui/material'
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers'
import moment from 'moment'
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment'
import { useDispatch } from 'react-redux'
import { hideLoader, showLoader } from '../../redux/Common/commonActions'

const ProvisionStatusReport = () => {
  const [Companies, setCompanies] = useState([])
  const [tableData, setTableData] = useState([])

  const [formData, setFormData] = useState({
    company: '',
    fromDate: '',
    toDate: ''
  })
  let dispatch = useDispatch()
  // Fiscal year end date state
  const [fiscalYearEnd, setFiscalYearEnd] = useState('')

  useEffect(() => {
    getRequest(`api/edureka/getCompanyAssignedToUser`)
      .then(({ res }) => {
        setCompanies(
          (res.data || []).sort((a, b) =>
            (a.orgname || "").localeCompare(b.orgname || ""),
          ),
        );
        if (res.data.length === 1) {
          handleChange("company", res.data[0]);
        }

        var currentDate = moment()
        var firstDay = currentDate.startOf('month').format('YYYY-MM-DD')
        var lastDay = currentDate.endOf('month').format('YYYY-MM-DD')
        setFormData(prev => ({ ...prev, fromDate: firstDay, toDate: lastDay }))
      })
      .catch((error) => console.log(error));
  }, [])

  const handleChange = (name, value) => {
    if (name === 'fromDate') {
      const fromDate = moment(value)

      if (fromDate.isValid() && fromDate.month() === 3 && fromDate.date() === 1) {
        // Correctly set fiscal year end to March 31st of the next year
        const fiscalEnd = fromDate.clone().add(1, 'year').month(2).date(31)

        // Format the date correctly
        setFiscalYearEnd(fiscalEnd.format('YYYY-MM-DD'))
      } else {
        setFiscalYearEnd('')
      }

      setFormData(prev => ({
        ...prev,
        [name]: value,
        toDate: '' // Reset toDate when fromDate changes
      }))
    } else if (name === 'toDate') {
      setFormData(prev => ({
        ...prev,
        [name]: value
      }))
    } else {
      setFormData(prev => ({
        ...prev,
        [name]: value
      }))
    }
  }

  const handleReset = () => {
    var currentDate = moment()
    var firstDay = currentDate.startOf('month').format('YYYY-MM-DD')
    var lastDay = currentDate.endOf('month').format('YYYY-MM-DD')
    setFormData({
      fromDate: firstDay,
      toDate: lastDay,
      company: ''
    })
    setTableData([])

  }

  const handleSubmit = e => {
    e.preventDefault()
    dispatch(showLoader())
    const { fromDate, toDate, company } = formData

    if (fromDate && toDate && company) {
      getRequest(
        `api/edureka/getProvisionStatusReport?fromDate=${fromDate}&toDate=${toDate}&company=${company.orgid}`
      )
        .then(response => {
          const responseData = JSON.parse(response.res.data)
          if (responseData.length) {
            setTableData(responseData)
          }
        })
        .catch(err => {
        })
        .finally(() => dispatch(hideLoader()))
    }
  }

  return (
    <>
      <Accordion defaultExpanded>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls='panel1-content'
          id='panel1-header'
        >
          <Typography variant='h6'>Search</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Grid container spacing={2}>
            <Grid item xs={1} sm={2} md={3}>
              <Autocomplete
                size="small"
                fullWidth
                value={formData?.company || null}
                options={Companies || []}
                getOptionLabel={(option) => option?.orgname || ""}
                isOptionEqualToValue={(option, value) =>
                  option?.orgid === value?.orgid
                }
                onChange={(event, newValue) =>
                  handleChange("company", newValue)
                }
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Company"
                    variant="outlined"
                    name="Company"
                  />
                )}
              />
            </Grid>

            <Grid item xs={1} sm={2} md={2}>
              <LocalizationProvider dateAdapter={AdapterMoment}>
                <DatePicker
                  label='From'
                  value={formData.fromDate}
                  inputFormat='DD-MM-YYYY'
                  minDate={moment().subtract(1, 'year').startOf('year')}
                  maxDate={moment().endOf('year')}
                  views={['year', 'month', 'day']}
                  onChange={newValue => handleChange('fromDate', moment(newValue).format('YYYY-MM-DD'))}
                  renderInput={params => (
                    <TextField fullWidth size='small' {...params} />
                  )}
                />
              </LocalizationProvider>
            </Grid>

            <Grid item xs={1} sm={2} md={2}>
              <LocalizationProvider dateAdapter={AdapterMoment}>
                <DatePicker
                  label='To'
                  value={formData.toDate}
                  inputFormat='DD-MM-YYYY'
                  minDate={moment().subtract(1, 'year').startOf('year')}
                  maxDate={moment().endOf('year')}
                  views={['year', 'month', 'day']}
                  onChange={newValue => handleChange('toDate', moment(newValue).format('YYYY-MM-DD'))}
                  renderInput={params => (
                    <TextField fullWidth size='small' {...params} />
                  )}
                />
              </LocalizationProvider>
            </Grid>

            <Grid item>
              <Button
                color='primary'
                variant='contained'
                onClick={handleSubmit}
                disabled={Object.values(formData).some(
                  data => data === '' || data === null
                )}
              >
                Submit
              </Button>
              <Button
                onClick={handleReset}
                style={{ marginLeft: '10px' }}
                color='error'
                variant='contained'
              >
                Reset
              </Button>
              {tableData.length ? (
                <Button color='success' variant='contained' style={{ marginLeft: '10px' }}>
                  <CSVLink
                    data={tableData}
                    filename='Provision_Status_Report.csv'
                    style={{ color: 'white', textDecoration: 'none' }}
                  >
                    Download
                  </CSVLink>
                </Button>
              ) : null}
            </Grid>
          </Grid>
        </AccordionDetails>
      </Accordion>

      {tableData.length ? (
        <NewDynamicTable data={tableData}></NewDynamicTable>
      ) : (
        <Box sx={{ margin: 'auto', mt: 2 }}>
          <Alert severity='warning'>
            <AlertTitle>No Data Found</AlertTitle>
            There is no data to display at the moment.
          </Alert>
        </Box>
      )}

    </>
  )
}

export default ProvisionStatusReport

